var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plan-ahead-transaction-label",on:{"click":function($event){$event.stopPropagation();return _vm.openPlanDetails.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.plan.name)+"  "+_vm._s(_vm.plan.unicodeIcon))])
}
var staticRenderFns = []

export { render, staticRenderFns }